<template>

  <div v-if="mode == 'min'">
    <template v-if="url == null">
    </template>

    <template v-else-if="isImage(url)">
      <div :key="`file_${id}`">
        <a :href="`${url}`" :data-lightbox="`file_img`">
          {{ filename || url.split('/').pop().split('.').slice(0, -1).join('.') }}
        </a>
      </div>
    </template>

    <template v-else-if="isPdf(url)">
      <div :key="`file_${id}`"> 
        <a href="javascript:;" @click="$bvModal.show(`modal-xl-${id}`)">
          {{ filename || url.split('/').pop().split('.').slice(0, -1).join('.') }}
        </a>
        <b-modal :id="`modal-xl-${id}`" title="Vista previa del PDF" size="xl" hide-footer>
          <div style="height: 80vh;">
            <iframe :src='url' type="application/pdf" width="100%" height="100%"></iframe>
          </div>
        </b-modal>
      </div>
    </template>

    <template v-else>
      <a :key="`file_${id}`" :href="url" target="_blank" class="file-link">
        {{ url.split('/').pop().split('.').slice(0, -1).join('.') }}
      </a>
    </template>
  </div>

  <div v-else>
    <template v-if="url == null || url.length == 0">
      <div :key="`file_${id}`" class="file-card">
        <span>Sin documento.</span>
      </div>
    </template>

    <template v-else-if="isImage(url)">
      <div :key="`file_${id}`" class="file-card">
        <a :href="url" :data-lightbox="`file_img`">
          <img width="300px" height="300px" :src="url" alt="imagen" class="img-fluid navbar-brand-img mt-2">
        </a>
        <div class="file-info">
          <span class="file-name">{{ url.split('/').pop() }}</span>
        </div>
      </div>
    </template>

    <template v-else-if="isPdf(url)">
      <div :key="`file_${id}`" class="file-card" @click="$bvModal.show(`modal-xl-${id}`)">
        <div class="pdf-icon">
          <i class="fa fa-file-pdf" style="font-size: 2em; color: #b03b3b;"></i>
        </div>

        <div class="file-info">
          <span class="pdf-name">{{ url.split('/').pop() }}</span>
        </div>

        <b-modal :id="`modal-xl-${id}`" title="Vista previa del PDF" size="xl" hide-footer>
          <div style="height: 80vh;">
            <iframe :src="url" type="application/pdf" width="100%" height="100%"></iframe>
          </div>
        </b-modal>
      </div>
    </template>

    <template v-else>
      <div :key="`file_${id}`" class="file-card">
        <a :href="url" target="_blank" class="file-link">
          <i class="fa fa-file" style="font-size: 2em;"></i>
        </a>
        <div class="file-info">
          <span class="file-name">{{ url.split('/').pop() }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'FileViewer',
  props: {
    id: {
      type: Number,
      required: true
    },
    url: {
      type: String || null,
      default: null,
      required: false
    },
    filename: {
      type: String,
      required: false
    },
    mode: {
      type: String,
      required: false
    }
  },
  methods: {
    isPdf(url) {
      return url.toLowerCase().endsWith('.pdf');
    },
    isImage(url) {
      console.log(url)
      return /\.(jpg|jpeg|png|gif|bmp|svg)$/i.test(url);
    }
  }
}
</script>
<style scoped>
.file-card {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 150px;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  background-color: #f8f8f8;
}

.file-card:hover {
  background-color: #ffe5e5;
}

.pdf-icon {
  margin-bottom: 10px;
}

.file-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.file-name {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-size: 1em;
  font-weight: bold;
  color: #b03b3b;
}

.pdf-size {
  font-size: 0.85em;
  color: #888;
}
</style>